import { Button, TextField } from '@mui/material';
import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #ffffff;

  display: flex;

  color: #000;
  position: relative;

  @media only screen and (max-width: 991px) {
    flex-direction: column;
  }
`;

export const LoginTopRightImg = styled.img`
  position: absolute;
  top: 0;
  right: 0;
`;

export const Left = styled.div`
  width: 50%;
  height: 100%;
  position: relative;
  
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;

export const BgImg = styled.img`
  height: 100%;
  width: 105%;
  position: absolute;
  z-index: 1;
`;

export const LeftContent = styled.div`
  position: absolute;
  top: 1.5rem;
  left: 1.5rem;
  width: calc(100% - 1.5rem);
  height: calc(100% - 3rem);
  z-index: 2;
  display: flex;
  border-radius: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1rem 4rem;
  background: #faf0ff;
  border: 1px solid #ebdbf2;

  h3 {
    color: #00000099;
  }

  h2 {
    display: flex;
    align-items: flex-end;
    font-size: 2rem;
    text-align: center;

    h3 {
      font-size: 2rem;
      color: #ffc700;
      text-decoration: underline;
      text-align: center;
    }
  }

  
  @media only screen and (max-width: 991px) {
    position: static;
    width: 100%;
    border-radius: 0;
  }
`;

export const Logo = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;

  h2 {
    font-weight: 600;
    font-size: 2rem;
    color: #000000;
  }
`;

export const FeatureImg = styled.img`
  width: 20rem;
  margin: 3rem 0;
`;

export const RightDetail = styled.div`
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 2rem 0;

  h2 {
    display: flex;
    align-items: flex-end;
    font-size: 1.3rem;

    h3 {
      color: #ffc700;
      text-decoration: underline;
    }
  }

  p {
    margin-top: 0.5rem;
    margin-bottom: 10vh;
    text-align: center;
    color: #0b1a3366;
  }

  @media only screen and (max-width: 991px) {
    /* display: flex; */
  }
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;

  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;

    width: 80%;
    max-width: 500px;

    @media only screen and (max-width: 991px) {
      width: 90%;
      margin: 0 0 5% 0;
    }
  }
`;

export const SocialLogin = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    font-size: 1.4rem;
  }
  p {
    color: #00000090;
  }
`;

export const GoogleBtn = styled.div`
  margin: 1.5rem 0 0.6rem;
  position: relative;
  cursor: pointer;
  padding: 1rem;

  #googleLoginBtn {
    position: absolute;
    top: 0;
    left: 50%;
    opacity: 0;
    z-index: 2;
    transform: translateX(-50%);
    background-color: green;
  }
`;

export const ActualBtn = styled.div`
  position: absolute;
  top: 0;

  width: max-content;
  height: max-content;
  display: flex;
  align-items: center;
  z-index: 1;

  transform: translateX(-50%);
  border: 1px solid #bbbbbb;
  padding: 0.4rem 1.75rem;
  border-radius: 0.5rem;

  p {
    flex-shrink: 0;
    color: #000;
    font-weight: 500;
    font-size: 1rem;
  }

  img {
    width: 2rem;
    height: 2rem;
    object-fit: contain;
    margin-right: 0.6rem;
  }
`;

export const OrDivider = styled.p`
  margin: 2rem 0;
  position: relative;
  color: #000000ba;
  font-size: 0.95rem;
  font-weight: 500;

  &::before {
    content: '';
    width: 60%;
    height: 0.6px;
    background-color: #00000080;
    position: absolute;
    left: 0%;
    top: 50%;
    transform: translate(-110%, -50%);

    @media only screen and (max-width: 991px) {
      width: 50%;
    }
  }

  &::after {
    content: '';
    width: 60%;
    height: 0.6px;
    background-color: #00000080;
    position: absolute;
    right: 0%;
    top: 50%;
    transform: translate(110%, -50%);

    @media only screen and (max-width: 991px) {
      width: 50%;
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 40px;
`;

export const InputLabel = styled.label``;

export const Input = styled.div`
  margin-bottom: 1.5rem;
  border-radius: 50% !important;
`;

export const FormBottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  margin-top: -1rem;
`;

export const FormBottomLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const SubmitBtn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 0.5rem;
  }
`;

export const WrongPassword = styled.div`
  width: 30rem;
  /* height: 25rem; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 1rem;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  outline: none;

  h3 {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  img {
    width: 15rem;
  }
`;

export const Para=styled.p`
    margin: 5px 0 0 0 !important;
    padding: 0 !important;
`;

export const FormHeader=styled.h3`
    margin: 0 0 !important;
    padding: 0 !important;
    font-weight: 700;
`;

export const Btn=styled(Button)`
    width: 100%;
    border-radius: 0.75rem;
    text-transform: none;
    font-family: 'Poppins, sans-serif';
    color: rgb(255, 255, 255);
    background: linear-gradient(270deg, rgb(0, 102, 255) 0%, rgb(0, 148, 255) 100%);
    padding: 10px 22px 8px !important;
`;

export const InputField=styled(TextField)`

    > .css-md26zr-MuiInputBase-root-MuiOutlinedInput-root{
    border-radius: 10px !important;
    }
    > .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root{
    border-radius: 10px !important;
    
    }
`;